import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Tab } from '@opengov/component-library/capital';
import { FigmaEmbed, PatternExample, UsageBlock } from '../../../components';
import LayoutComponents from '../../../components/capital/Layouts/LayoutComponents';
export const _frontmatter = {
  "title": "Tabs",
  "componentId": "tabs",
  "description": "Tabs are used to navigate between content blocks on a page.",
  "activeTab": "components"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = LayoutComponents;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><strong parentName="p">{`Documentation in progress-----------------------`}</strong></p>
    <p>{`Use tabs to navigate between tasks. Although not limited to actions words, tab titles could be action words that reflect the tasks. For example: Explore, Manage, Preview, Analyze...`}</p>
    <h2>{`Variants`}</h2>
    <PatternExample width="full" example={<Tab.Group activeTabIndex={0}>
    <Tab.Option label="First tab">
      <p>Content for the first tab</p>
    </Tab.Option>
    <Tab.Option label="Second tab">
      <p>Content for the second tab</p>
    </Tab.Option>
    <Tab.Setting>
      <p>Content for the settings tab</p>
    </Tab.Setting>
  </Tab.Group>} mdxType="PatternExample" />
    <h3>{`Configuration`}</h3>
    <PatternExample width="full" example={<Tab.Group activeTabIndex={0}>
    <Tab.Option activeBackgroundColor="white" label="First tab">
      <p>Content for the first tab</p>
    </Tab.Option>
    <Tab.Option activeBackgroundColor="white" label="Second tab">
      <p>Content for the second tab</p>
    </Tab.Option>
    <Tab.Setting activeBackgroundColor="white">
      <p>Content for the settings tab</p>
    </Tab.Setting>
  </Tab.Group>} mdxType="PatternExample" />
    <h3>{`Usage`}</h3>
    <UsageBlock mdxType="UsageBlock">
  <UsageBlock.Correct>
    <p>...</p>
  </UsageBlock.Correct>
  <UsageBlock.Incorrect>
    <p>...</p>
  </UsageBlock.Incorrect>
    </UsageBlock>
    <h2>{`Layout`}</h2>
    <PatternExample example={"..."} title="..." description={"Description about layout structure"} mdxType="PatternExample" />
    <h2>{`Content`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      